import { render, staticRenderFns } from "./VehicleCarousel.vue?vue&type=template&id=b4e05ee2&scoped=true&"
import script from "./VehicleCarousel.vue?vue&type=script&lang=js&"
export * from "./VehicleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCarousel.vue?vue&type=style&index=0&id=b4e05ee2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e05ee2",
  null
  
)

export default component.exports